import {getStationCode, logOperationalMetric} from "../../util/CommonUtils";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
const metricProcessName = "SCC_PACKAGE_SEARCH";

function getCPTDataAPIGatewayRequest(request) {
    return {
        resourcePath: "/os/getStationCPTs",
        httpMethod: "post",
        processName: "oculus",
        requestBody: request
    }
}

export function fetchCPTList(dispatcher) {
    const request = {
        nodeId: getStationCode(),
    }

    const args = getCPTDataAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {

        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getCPTData", true);
            const output = result.data;
            let data= JSON.parse(output.CPTList).filter(CPT => CPT.label !== 'ALL')

            dispatcher({type: "RECEIVE_CPT", data: {CPT: data}})
            dispatcher({type: "ASSIGN_LABEL", data: {CPTLabel: ( output.CPTTypeLabelKey === null ? "cpt" : output.CPTTypeLabelKey )}})
            dispatcher({type: "ASSIGN_FILTER_IDENTIFIER", data: {filterIdentifier: ( output.filterIdentifier === null ? "CPT" : output.filterIdentifier )}})
        } else {
            logOperationalMetric(startTime, metricProcessName, "getCPTData", false);
        }
    });
}


// WEBPACK FOOTER //
// ./src/commons/api/GetCPTList.js